<template>
  <div class="border">
    <template>
      <div 
      v-for="(row, index) of warehouseList" 
      :key="index" 
      class="warehouseList"
      :class="[ isWarehouseSelected(row) ? 'selectedRow' : '' ]">
      <div class="fields">
        <sc-field label="Centro de Distribuição">
          <sc-input :disabled="true" :value="row.name"></sc-input>
        </sc-field>

        <sc-field label="CNPJ">
          <sc-input :disabled="true" :value="row.federal_tax_payer_id"></sc-input>
        </sc-field>

        <sc-field label="CEP">
          <sc-input :disabled="true" :value="row.address.zip_code"></sc-input>
        </sc-field>

        <!-- <div class="configurationIcons">
          <p class="label">Configurado</p>
          <sc-icon icon="check" class="check" v-if="hasConfiguration"/>
          <sc-icon icon="times" class="error" v-else/>
        </div> -->
      </div>

        <div class="buttons">
          <sc-button theme="danger" @click="removeRow(index)" v-if="!hasConfiguration">Excluir</sc-button>
  
          <sc-button @click="selectRow(row)">Configuração</sc-button>
        </div>
      </div>

      <div v-if="!hasConfiguration">
        <sc-field label="Centro de Distribuição">
          <sc-select v-model="selected_warehouse" :loading="loading">
            <option 
              class="selectWarehouse"
              v-for="(warehouse, index) of warehouses" 
              :key="index" 
              :value="warehouse" 
              :disabled="isWarehouseInUse(warehouse)">
              {{ warehouse.name }}
            </option>
          </sc-select>
        </sc-field>
        <sc-button :disabled='!selected_warehouse' @click="addRow">Adicionar</sc-button>
      </div>
    </template>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import { ScField, ScInput, ScSelect, ScButton, ScIcon } from '@intelipost-js/secure-components';

const { mapActions, mapMutations, mapState } = createNamespacedHelpers('integrations/integrationsStep');
export default {
  name: 'sc-warehouses-list',
  props: {
    hasConfiguration: {
      type: Boolean,
    },
  },
  data() {
    return {
      warehouses: [{}],
      selected_warehouse: null,
      selectedItem: null,
    };
  },
  created() {
    this.getWarehouses().then((response) => {
      this.warehouses = response;
    });
  },
  computed: {
    ...mapState(['warehouseList', 'loading']),
  },
  methods: {
    ...mapActions(['getWarehouses']),
    ...mapMutations(['setWarehouseList']),

    addRow() {
      const newWarehouseList = [...this.warehouseList];
      newWarehouseList.push(this.selected_warehouse);

      this.setWarehouseList(newWarehouseList);
      this.$root.$emit('add-warehouse', this.selected_warehouse);
      this.selected_warehouse = null;
    },
    removeRow(index) {
      this.$root.$emit('remove-warehouse', this.warehouseList[index]);
      this.setWarehouseList(this.warehouseList.filter((row, i) => i !== index));
    },
    setSelectedWarehouse(warehouseId) {
      const selected = this.warehouseList.find(row => row.id === warehouseId);
      this.selectRow(selected);
    },
    selectRow(row) {
      this.$root.$emit('select-warehouse', row);
      this.selectedItem = row;
      this.setWarehouseList([...this.warehouseList]);
    },
    isWarehouseInUse(warehouse) {
      return this.warehouseList.some(row => row === warehouse);
    },
    isWarehouseSelected(row) {
      return this.selectedItem && this.selectedItem.id === row.id;
    },
  },
  components: {
    ScField,
    ScInput,
    ScSelect,
    ScButton,
    ScIcon,
  },
};
</script>

<style lang="scss" scoped>

  .border {
   width: 60%; 
   display: flex;
   flex-direction: column;
   gap: 10px;
  }
  .warehouseList {
    display: flex;
    flex-direction: column;
    gap: 20px;
    border: 1px solid #d9d9d9;
    padding: 15px;
    align-items: center;
  }
  .check {
    color: #09a83d;
    font-size: 1.6em;
    padding-left: 30px;
  }
  .error {
    color: #ff0000;
    font-size: 1.6em;
  }
  .selectWarehouse:disabled{
    background-color: #7a7a7a;
    color: #fff;
  }

  .selectedRow {
    border-color: #002b17;
  }

  .fields {
    display: flex;
    width: 100%;
    flex-direction: column;
  }
  
  .configurationIcons {
    align-self: center;
    text-align: center;
  }
</style>


// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/features/integrations-app-v2/components/sc-warehouses-list/ScWarehousesList.vue